/**
 * @fileoverview API layer for AI credit balance and usage. All endpoint
 * knowledge for this feature lives here; components call these named functions
 * and never assemble URLs themselves.
 */
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config";

const BASE = `${config.POSTLOGIN_API_URL_COMPANY}ai-credits`;

/**
 * Loads the company's credit balance and per-feature usage.
 *
 * @returns {Promise<object>} Envelope carrying the usage summary.
 *
 * @remarks
 * Alerts are suppressed. This panel is secondary content on pages whose primary
 * job is something else, so a billing read that fails should leave the panel in
 * an error state rather than throwing a modal over the page the user came for.
 */
export const getAiUsage = () =>
  apiCall(`${BASE}/usage`, {}, {}, "GET", false, false);
